/* eslint no-undef: "warn" */

import 'whatwg-fetch'
// eslint-disable-next-line no-undef
export default self.fetch.bind(self)
// eslint-disable-next-line no-undef
export const Headers = self.Headers
// eslint-disable-next-line no-undef
export const Request = self.Request
// eslint-disable-next-line no-undef
export const Response = self.Response
